import { Effect } from "../../Materials/effect";
/** @hidden */
var WebGPUShaderManager = /** @class */ (function () {
    function WebGPUShaderManager(device) {
        this._shaders = {};
        this._device = device;
    }
    WebGPUShaderManager.prototype.getCompiledShaders = function (name) {
        var shaders = this._shaders[name];
        if (!shaders) {
            shaders = this._shaders[name] = {
                vertexStage: {
                    module: this._device.createShaderModule({
                        code: Effect.ShadersStore[name + "VertexShader"]
                    }),
                    entryPoint: 'main'
                },
                fragmentStage: {
                    module: this._device.createShaderModule({
                        code: Effect.ShadersStore[name + "PixelShader"]
                    }),
                    entryPoint: 'main'
                }
            };
        }
        return shaders;
    };
    return WebGPUShaderManager;
}());
export { WebGPUShaderManager };
//# sourceMappingURL=webgpuShaderManager.js.map